/**
 * @file Re-exports the U.S. tax withholding notice modal and its hook.
 */
import UsTaxWithholdingNoticeModal from "./UsTaxWithholdingNoticeModal";

export default UsTaxWithholdingNoticeModal;
export { default as useUsTaxWithholdingNotice } from "./useUsTaxWithholdingNotice";
